import { put } from 'redux-saga/effects';
import CustomersActions from '../redux/CustomersRedux';
import i18n from '../i18n';
import decode from 'jwt-decode';

export function* getCustomers(api) {
  try {
    const customersResponse = yield api.getCustomers();
    console.log('customersResponse:', customersResponse);
    if (customersResponse.ok) {
      const { data } = customersResponse;
      const customersWithSub = data.map((customer) => {
        const decodedToken = customer && customer.customerId ? decode(customer.customerId) : null;
        const customerIdSub = decodedToken ? decodedToken.sub : null;
        return { ...customer, customerIdSub };
      });
      yield put(CustomersActions.customersRequestSuccess(customersWithSub));
    } else {
      api.checkAuth(customersResponse);
      const error =
        typeof customersResponse.problem !== 'undefined'
          ? customersResponse.problem
          : typeof customersResponse.data.error !== 'undefined'
          ? i18n.t(customersResponse.data.error)
          : i18n.t('unexpectedError');
      yield put(CustomersActions.customersRequestFailure(error));
      // alert(error);
    }
  } catch (error) {
    console.log('error in customers saga', error);
    yield put(CustomersActions.customersRequestFailure(error));
  }
}

export function* getCustomersByDistributor(api, { distributorId, pageParams }) {
  try {
    const customersByDistributorResponse = yield api.getCustomersByDistributor(distributorId, pageParams);
    console.log('customersByDistributorResponse:', customersByDistributorResponse);
    if (customersByDistributorResponse.ok) {
      const content = customersByDistributorResponse.data.content;
      const customersWithSub = content.map((customer) => {
        const decodedToken = customer && customer.customerId ? decode(customer.customerId) : null;
        const customerIdSub = decodedToken ? decodedToken.sub : null;
        return { ...customer, customerIdSub };
      });
      yield put(CustomersActions.getCustomersByDistributorRequestSuccess(customersWithSub));
    } else {
      api.checkAuth(customersByDistributorResponse);
      const error =
        typeof customersByDistributorResponse.problem !== 'undefined'
          ? customersByDistributorResponse.problem
          : typeof customersByDistributorResponse.data.error !== 'undefined'
          ? i18n.t(customersByDistributorResponse.data.error)
          : i18n.t('unexpectedError');
      yield put(CustomersActions.getCustomersByDistributorRequestFailure(error));
      // alert(error);
    }
  } catch (error) {
    console.log('error in customers saga', error);
    yield put(CustomersActions.getCustomersByDistributorRequestFailure(error));
  }
}

export function* getCustomersForAdmin(api, { distributorId, pageParams }) {
  try {
    const customersForAdminResponse = yield api.getCustomersByDistributor(distributorId, pageParams);
    console.log('customersForAdminResponse:', customersForAdminResponse);
    if (customersForAdminResponse.ok) {
      const content = customersForAdminResponse.data.content;
      const customersWithSub = content.map((customer) => {
        const decodedToken = customer && customer.customerId ? decode(customer.customerId) : null;
        const customerIdSub = decodedToken ? decodedToken.sub : null;
        return { ...customer, customerIdSub };
      });
      yield put(CustomersActions.getCustomersForAdminRequestSuccess(customersWithSub, customersForAdminResponse.data?.totalElements));
    } else {
      api.checkAuth(customersForAdminResponse);
      const error =
        typeof customersForAdminResponse.problem !== 'undefined'
          ? customersForAdminResponse.problem
          : typeof customersForAdminResponse.data.error !== 'undefined'
          ? i18n.t(customersForAdminResponse.data.error)
          : i18n.t('unexpectedError');
      yield put(CustomersActions.getCustomersForAdminRequestFailure(error));
      // alert(error);
    }
  } catch (error) {
    console.log('error in customers saga', error);
    yield put(CustomersActions.getCustomersForAdminRequestFailure(error));
  }
}

export function* createCustomer(api, { customerInfos, distributorId, pageParams }) {
  console.log('distributorId:', distributorId);
  try {
    const createCustomerResponse = yield api.createCustomer(customerInfos);
    console.log('createCustomerResponse:', createCustomerResponse);
    const customersByDistributorResponse = yield api.getCustomersByDistributor(distributorId, pageParams);
    console.log('customersByDistributorResponse:', customersByDistributorResponse);
    const successMessage = i18n.t('successMessage.createCustomer');
    if (createCustomerResponse.ok && customersByDistributorResponse.ok) {
      const content = customersByDistributorResponse.data.content;
      const customersWithSub = content.map((customer) => {
        const decodedToken = customer && customer.customerId ? decode(customer.customerId) : null;
        const customerIdSub = decodedToken ? decodedToken.sub : null;
        return { ...customer, customerIdSub };
      });
      yield put(
        CustomersActions.createCustomerRequestSuccess(
          createCustomerResponse?.data?.customerId,
          createCustomerResponse?.data?.address?.addressId,
          customersWithSub,
          customersByDistributorResponse?.data?.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(createCustomerResponse);
      api.checkAuth(customersByDistributorResponse);
      const error =
        typeof createCustomerResponse.problem !== 'undefined'
          ? createCustomerResponse.problem
          : typeof createCustomerResponse.data.error !== 'undefined'
          ? i18n.t(createCustomerResponse.data.error)
          : i18n.t('unexpectedError');
      yield put(CustomersActions.createCustomerRequestFailure(error));
    }
  } catch (error) {
    console.log('error in Customer saga', error);
    yield put(CustomersActions.createCustomerRequestFailure(error));
  }
}

export function* editCustomer(api, { customerInfos, distributorId, pageParams }) {
  console.log('distributorId:', distributorId);
  try {
    const editCustomerResponse = yield api.editCustomer(customerInfos);
    console.log('editCustomerResponse:', editCustomerResponse);
    const customersByDistributorResponse = yield api.getCustomersByDistributor(distributorId, pageParams);
    console.log('customersByDistributorResponse:', customersByDistributorResponse);
    const successMessage = i18n.t('successMessage.editCustomer');
    if (editCustomerResponse.ok && customersByDistributorResponse.ok) {
      const content = customersByDistributorResponse.data.content;
      console.log(
        'customersByDistributorResponse?.data?.totalElements:',
        customersByDistributorResponse?.data?.totalElements
      );
      const customersWithSub = content.map((customer) => {
        const decodedToken = customer && customer.customerId ? decode(customer.customerId) : null;
        const customerIdSub = decodedToken ? decodedToken.sub : null;
        return { ...customer, customerIdSub };
      });
      yield put(
        CustomersActions.editCustomerRequestSuccess(
          customersWithSub,
          successMessage,
          customersByDistributorResponse?.data?.totalElements
        )
      );
    } else {
      api.checkAuth(editCustomerResponse);
      api.checkAuth(customersByDistributorResponse);
      const error =
        typeof editCustomerResponse.problem !== 'undefined'
          ? editCustomerResponse.problem
          : typeof editCustomerResponse.data.error !== 'undefined'
          ? i18n.t(editCustomerResponse.data.error)
          : i18n.t('unexpectedError');
      yield put(CustomersActions.editCustomerRequestFailure(error));
    }
  } catch (error) {
    console.log('error in Customer saga', error);
    yield put(CustomersActions.editCustomerRequestFailure(error));
  }
}

export function* deleteCustomer(api, { customerId, distributorId, pageParams }) {
  console.log('customerId:', customerId);
  try {
    const deleteCustomerResponse = yield api.deleteCustomer(customerId);
    console.log('deleteCustomerResponse:', deleteCustomerResponse);
    const customersByDistributorResponse = yield api.getCustomersByDistributor(distributorId, pageParams);
    console.log('customersByDistributorResponse:', customersByDistributorResponse);
    const successMessage = i18n.t('successMessage.deleteCustomer');
    if (deleteCustomerResponse.ok && customersByDistributorResponse.ok) {
      const content = customersByDistributorResponse.data.content;
      const customersWithSub = content.map((customer) => {
        const decodedToken = customer && customer.customerId ? decode(customer.customerId) : null;
        const customerIdSub = decodedToken ? decodedToken.sub : null;
        return { ...customer, customerIdSub };
      });
      yield put(CustomersActions.deleteCustomerRequestSuccess(customersWithSub, successMessage));
    } else {
      api.checkAuth(deleteCustomerResponse);
      api.checkAuth(customersByDistributorResponse);
      const error =
        typeof deleteCustomerResponse.problem !== 'undefined'
          ? deleteCustomerResponse.problem
          : typeof deleteCustomerResponse.data.error !== 'undefined'
          ? i18n.t(deleteCustomerResponse.data.error)
          : i18n.t('unexpectedError');
      yield put(CustomersActions.deleteCustomerRequestFailure(error));
    }
  } catch (error) {
    console.log('error in customers saga', error);
    yield put(CustomersActions.deleteCustomerRequestFailure(error));
  }
}
